module.exports = {
	'shift.hp.m3.m310410_inspection.group_config_dialog': {
		'selectAGroupClass': '选择群组班别',
		'selectALabel': '选择标签',
	},
	'shift.hp.m3.m310410_inspection.inspect_config': {
		'selectedClass': '已選班別',
		'theFileFormatIsIncorrect': '档案格式错误',
		'postsShouldBeRearrangedForManpower': '岗位应排人力汇入',
	},
	'shift.m4.m410210': {
		'saveAndSubmitSchedules': '储存并提交班表',
		'scheduleStatus': '班表状态',
		'previewStatus': '预排状态'
	},
	'shift.am.Shifting': {
		'workingHours': '工作时间',
		'breaks': '休息时间',
	},
	'shift.am.ShiftingFieldSetting': {
		'theNumberOfBlockedColumnsCannot': '冻结栏位不可超过 10 个',
		'open': '开启',
		'theLeftSideFreezes': '左侧冻结',
		'theRightSideFreezes': '右侧冻结',
	},
	'ai-shift.m3.m310410_ai_shift.dialog': {
		'manpowerAllocation': '人力配置',
		'staffScheduling': '员工预排',
		'generatingYourScheduleData': '正在为你生成班表数据...',
		'byUnderstandingYourSchedulingConsiderationsI': '通过了解你的排班考量，我会快速生成班表，请先告诉我你的考量？',
		'aISchedulingConsiderations': 'AI 排班考量',
		'minimumCost': '最低成本',
		'averageWorkingHours': '工时平均',
		'mustMeetTheRequirements': '需符合条件',
		'startGeneratingTheSchedule': '开始生成班表',
		'downloadGeneratedResults': '下载生成结果',
		'workingHoursRegulations': '工时规则',
		'employeeManagement': '员工管理',
		'humanResourceAllocation2': '人力配置',
		'workingHoursRegulationsHint': '选填，建议勾选，让 AI 在排班时即纳入工时规则规范。若未勾选，系统仍会在“保存班表”时再次检核工时规则。',
		'aISchedulingBasisAndDataUsageScope': 'AI 排班依据与资料使用范围',
		'schedulingIsBasedOnlyOnResourceAllocation': '排班仅依据“人力配置、员工可上班时间、标签、工时规则、员工预排”进行。系统不会收集或使用可上班时间背后的原因（如怀孕、宗教、健康或家庭照顾因素）作为排班依据。',
	},
	'ai-shift.m3.m310410_ai_shift.resource_allocation': {
		'editManpowerAllocation': '编辑人力配置',
		'queryManpowerAllocation': '查询人力配置',
		'yYYYMMDD': 'YYYY/MM/DD',
		'person': '人',
	},
	'ai-shift.m3.m310410_new': {
		'aIHelpsYouScheduleShifts': 'AI 帮你排班',
		'rescheduleAIShifts': '重新 AI 排班',
		'differenceDate': '差异日期',
	},
	'ai-shift.m3.m310410_shifting': {
		'whyGenerateThisScheduleForYou': '为何生成这个班表给你？',
		'basedOnYourSchedulingConsiderationsFor': '根据您选择的参数，我们为您排定了这个班表。此班表与您的需求高度契合，综合考量了员工管理、人力配置、工时规则、员工预排，让整体排班更公平且合法。',
	},
	'ai-shift.m3.m310320_grid': {
		'theDataHasBeenDeletedAnd': '数据已删除，无法保存。',
		'overnightShiftsOnlyDisplayTheCurrent': '跨夜班次仅显示当日时段，AI 排班会依完整时段排班。',
		'forShiftsThatSpanOvernightE': '班次为跨夜班次（如：前日 20:00 至当日 04:00），画面将仅显示当日部分（00:00 - 04:00）。请放心，AI 自动排班仍会依据完整时段进行逻辑计算，不影响实际排班结果。',
	},
	'ai-shift.m3.m310320': {
		'groupsCannotBeDuplicated': '群組不可重复',
	},
	'ai-shift.service.m3.service-m310320': {
		'theCurrentlySelectedClassIsNo': '目前选取的<%=temp1%>已不适用，请重新选择有效班次并保存。',
	},
	'ai-shift.service.m3.service-m310410-ai-shift': {
		'whenTheNumberOfScheduledPersonnel': '当排班人数超过 100 人时，为了确保排班效率与最优结果，暂不建议直接使用 AI 自动排班功能。',
		'beforeAIHelpsYouScheduleYou': 'AI帮你排班前，需要先设定人力配置资料。 \n请至人力配置，设定至少一天的需求人力。',
		'insufficientManpowerToScheduleShiftsPlease': '人力不足无法排班\n请调整人力配置',
		'lackingEmployeesWith': '缺乏具备 <%=temp1%> 的员工',
		'aSystemEnvironmentErrorHasOccurred': '系统环境发生错误，请联络 104 HR Max FAE 工程师。',
	},
	'ai-shift.m3.m310410_ai_shift.compare': {
		'datesWithDifferencesBetweenAIScheduling': 'AI 排班结果与人力配置有差异的日期',
	},
};
